<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="pic-hd"><img src="../assets/images/img-01.jpg" alt=""></div>
        <div class="tabsw01">
            <div class="item" :class="{active: tabActive == 0}" @click="tabActive = 0">开发区动态</div>
            <div class="item" :class="{active: tabActive == 1}" @click="tabActive = 1">开发区政策</div>
            <div class="item" :class="{active: tabActive == 2}" @click="tabActive = 2">一区多园</div>
        </div>
        <van-list
                v-show="tabActive == 0"
                v-model="tab0.loading"
                :finished="tab0.finished"
                finished-text="没有更多了"
                @load="onLoad">
            <router-link :to="{path: 'DetailInfoView', query: {id: item.info_id}}" class="listw02-item" v-for="(item, index) in tab0.list" :key="index">
                <div class="listw02-item-pic"><img :src="downPath + item.thumbnail" alt=""></div>
                <div class="listw02-item-txt">
                    <div class="listw02-item-name">{{ item.title }}</div>
                    <div class="listw02-item-info"><span>{{ item.author }}</span><span>{{ item.create_time }}</span></div>
                    <div class="listw02-item-desc">{{ item.description }}</div>
                </div>
            </router-link>
        </van-list>
        <van-list
                v-show="tabActive === 1"
                v-model="tab1.loading"
                :finished="tab1.finished"
                finished-text="没有更多了"
                @load="onLoad">
            <router-link :to="{path: 'DetailInfoView', query: {id: item.info_id}}" class="listw02-item" v-for="(item, index) in tab1.list" :key="index">
                <div class="listw02-item-pic"><img :src="downPath + item.thumbnail" alt=""></div>
                <div class="listw02-item-txt">
                    <div class="listw02-item-name">{{ item.title }}</div>
                    <div class="listw02-item-info"><span>{{ item.author }}</span><span>{{ item.create_time }}</span></div>
                    <div class="listw02-item-desc">{{ item.description }}</div>
                </div>
            </router-link>
        </van-list>
        <van-list
                v-show="tabActive === 2"
                v-model="tab2.loading"
                :finished="tab2.finished"
                finished-text="没有更多了"
                @load="onLoad">
            <div class="listw01-item" v-for="item in tab2.list">
                <div class="listw01-item-pic">
                    <router-link :to="{path: 'Property', query: {id: item.building_id}}">
                        <img :src="downPath + item.main_img" alt="">
                    </router-link>
                </div>
                <div class="listw01-item-txt">
                    <router-link :to="{path: 'Property', query: {id: item.building_id}}">
                        <div class="listw01-item-name">{{ item.building_name }}</div>
                        <div class="listw01-item-info"><div class="lab">地址：</div><div class="val">{{ item.address }}</div></div>
                        <div class="listw01-item-info"><div class="lab">面积：</div><div class="val">{{ item.building_area }}㎡</div></div>
                        <div class="listw01-item-price">价格：40000元/㎡</div>
                        <div class="listw01-item-tags"><span>产业园</span><span>在售</span><span>软件服务与外包</span></div>
                    </router-link>
                    <a class="listw01-item-tel" :href="'tel:'+item.contact_mobile"></a>
                </div>
            </div>
        </van-list>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { List } from 'vant';
    export default {
        name: "DevelopmentTwo",
        data: function () {
            return {
                tabActive: 0,
                development_zone_id: '',
                typeList: ['dynamic', 'policy', 'building'],
                downPath: '',
                tab0: {
                    loading: false,
                    finished: false,
                    page: 1,
                    list: []
                },
                tab1: {
                    loading: false,
                    finished: false,
                    page: 1,
                    list: []
                },
                tab2: {
                    loading: false,
                    finished: false,
                    page: 1,
                    list: []
                }
            }
        },
        components: {
            Header, Footer,
            [List.name]: List
        },
        mounted(){
            this.downPath = this.api.downPath;
            this.tabActive = this.$route.query.active;
            this.development_zone_id = this.$route.query.id;
            this.getList();
        },
        methods: {
            getList(){
                const _this = this;
                _this.api.getDevelopmentView({
                    development_zone_id: _this.development_zone_id,
                    type: _this.typeList[_this.tabActive],
                    pageSize: 20,
                    page: _this['tab' + _this.tabActive].page
                }).then(function(response){
                    _this['tab' + _this.tabActive].loading = false;
                    _this['tab' + _this.tabActive].page++;
                    if (_this.tabActive == 2) {
                        if (response.development_zone_building_list.length == 0) {
                            _this['tab' + _this.tabActive].finished = true;
                        }
                        _this['tab' + _this.tabActive].list = _this['tab' + _this.tabActive].list.concat(response.development_zone_building_list)
                    } else {
                        if (response[_this.typeList[_this.tabActive] + '_info_list'].length == 0) {
                            _this['tab' + _this.tabActive].finished = true;
                        }
                        _this['tab' + _this.tabActive].list = _this['tab' + _this.tabActive].list.concat(response[_this.typeList[_this.tabActive] + '_info_list'])
                    }
                })
            },
            onLoad: function(){
                setTimeout(()=>{
                    this.getList();
                }, 500)
            },
        },
        watch: {
            tabActive: function(){
                this['tab' + this.tabActive].page = 1;
                this['tab' + this.tabActive].list = [];
                this.getList();
            }
        }
    }
</script>

<style scoped>
    /deep/ .listw02-item-name {white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;-webkit-box-orient: initial;-webkit-line-clamp: initial}
    /deep/ .listw02-item-info {font-size: .2rem;margin-bottom: .1rem;}
    /deep/ .listw02-item-desc {font-size: .24rem;color: #666;-webkit-line-clamp: 2;display: -webkit-box;-webkit-box-orient: vertical;overflow: hidden;}
</style>